import React, { useEffect, useState } from "react";
import { useWatchState } from "@/store";
import { BaseService } from "@/service";
import { Comment, DealBtnPark } from "@/module";
import { Modal, Icon } from "antd";
import { checkResult, createFilePath, second2Date } from "@/common";
import "./style.less";

const NAME = "parkInfo";

const App = () => {
  const [[UPLOAD_SERVER_HOST = ""]] = useWatchState(["$_UPLOAD_SERVER_HOST"]);
  const [[{ title = "园区详情", show, hide, width = 1200, resultId = "" }]] =
    useWatchState(["modal." + NAME]);

  const [data, setData] = useState({});

  useEffect(() => {
    if (resultId) {
      BaseService.list({
        table: "thtt_yuanqu",
        columns:
          "yuanqu_id,name,add_time,region_bg,build_bg,ecology_bg,link_bg,merchants,financial_support_policy,incentive_policy,talent_attraction_policy,supporting_policy,innovation_policy,contacts,contacts_tel",
        where: {
          yuanqu_id: resultId,
          "thtt_yuanqu.is_delete": 0,
        },
        process: {
          name: "files",
          key: "yuanqu_id",
          targetKey: "item_id",
          params: {
            table: "thtt_attachment_relation",
          },
        },
      }).then((res) => {
        if (!checkResult(res)) return;
        const data = res.data.result[0] || {};
        setData(data);
      });
    } else setData({});
  }, [resultId]);

  return (
    <Modal
      title={title}
      visible={show}
      width={width}
      maskClosable={false}
      destroyOnClose
      onCancel={hide}
      footer={false}
      className="modal-parkInfo"
    >
      <h2>{data.name}</h2>
      <p className="dark-disable">{second2Date(data.add_time)}</p>

      {/* 产业园区机构背景介绍 */}

      {data.region_bg !== "<p></p>" && (
        <article className="m-md-t">
          <h2 className="modal-resultInfo-title-second">产业园区地区背景</h2>
          <div
            className="m-sm-t braft-output-content"
            dangerouslySetInnerHTML={{ __html: data.region_bg }}
          ></div>
        </article>
      )}
      {data.build_bg !== "<p></p>" && (
        <article className="m-md-t">
          <h2 className="modal-resultInfo-title-second">产业园区建设背景</h2>
          <div
            className="m-sm-t"
            dangerouslySetInnerHTML={{ __html: data.build_bg }}
          ></div>
        </article>
      )}
      {data.ecology_bg !== "<p></p>" && (
        <article className="m-md-t">
          <h2 className="modal-resultInfo-title-second">产业园区生态背景</h2>
          <div
            className="m-sm-t"
            dangerouslySetInnerHTML={{ __html: data.ecology_bg }}
          ></div>
        </article>
      )}
      {data.link_bg !== "<p></p>" && (
        <article className="m-md-t">
          <h2 className="modal-resultInfo-title-second">产业集群链条背景</h2>
          <div
            className="m-sm-t"
            dangerouslySetInnerHTML={{ __html: data.link_bg }}
          ></div>
        </article>
      )}

      {/* 园区招商产业方向介绍 */}

      {data.merchants !== "<p></p>" && (
        <article className="m-md-t">
          <h2 className="modal-resultInfo-title-second">
            园区招商产业方向介绍
          </h2>
          <div
            className="m-sm-t"
            dangerouslySetInnerHTML={{ __html: data.merchants }}
          ></div>
        </article>
      )}

      {/* 园区招商引资政策介绍 */}

      {data.financial_support_policy !== "<p></p>" && (
        <article className="m-md-t">
          <h2 className="modal-resultInfo-title-second">金融支持政策</h2>
          <div
            className="m-sm-t"
            dangerouslySetInnerHTML={{ __html: data.financial_support_policy }}
          ></div>
        </article>
      )}
      {data.incentive_policy !== "<p></p>" && (
        <article className="m-md-t">
          <h2 className="modal-resultInfo-title-second">招商奖励政策</h2>
          <div
            className="m-sm-t"
            dangerouslySetInnerHTML={{ __html: data.incentive_policy }}
          ></div>
        </article>
      )}
      {data.talent_attraction_policy !== "<p></p>" && (
        <article className="m-md-t">
          <h2 className="modal-resultInfo-title-second">人才吸引政策</h2>
          <div
            className="m-sm-t"
            dangerouslySetInnerHTML={{ __html: data.talent_attraction_policy }}
          ></div>
        </article>
      )}
      {data.supporting_policy !== "<p></p>" && (
        <article className="m-md-t">
          <h2 className="modal-resultInfo-title-second">产业扶持政策</h2>
          <div
            className="m-sm-t"
            dangerouslySetInnerHTML={{ __html: data.supporting_policy }}
          ></div>
        </article>
      )}
      {data.innovation_policy !== "<p></p>" && (
        <article className="m-md-t">
          <h2 className="modal-resultInfo-title-second">科技创新政策</h2>
          <div
            className="m-sm-t"
            dangerouslySetInnerHTML={{ __html: data.innovation_policy }}
          ></div>
        </article>
      )}

      {/* 园区招商引资宣传资料 */}

      {data.files &&
        !!data.files.filter(({ type }) => type === "enclosure").length && (
          <article className="m-md-t">
            <h2 className="modal-resultInfo-title-second">
              园区招商引资宣传资料
            </h2>
            <div className="flex flex-col child-top-sm m-sm-t">
              {(data.files || [])
                .filter(({ type }) => type === "enclosure")
                .map(({ file_name, file_path }) => (
                  <a href={createFilePath(file_path, UPLOAD_SERVER_HOST)}>
                    <Icon type="link" /> {file_name}
                  </a>
                ))}
            </div>
          </article>
        )}

      {/* 园区建设实景图片集锦 */}

      {data.files &&
        !!data.files.filter(({ type }) => type === "covers").length && (
          <article className="m-md-t">
            <h2 className="modal-resultInfo-title-second">
              园区建设实景图片集锦
            </h2>
            <div className="flex m-sm-t over-auto" style={{ height: "200px" }}>
              {(data.files || [])
                .filter(({ type }) => type === "covers")
                .map(({ file_name, file_path }) => (
                  <img
                    className="h-full object-cover m-sm-r"
                    src={createFilePath(file_path, UPLOAD_SERVER_HOST)}
                    alt=""
                  />
                ))}
            </div>
          </article>
        )}

      <article className="m-md-t">
        <h2 className="modal-resultInfo-title-second">联系我们</h2>
        <div className="m-sm-t">
          <p>
            {data.contacts} {data.contacts_tel}
          </p>
        </div>
      </article>

      <article className="m-md-t">
        <h2 className="modal-resultInfo-title-second">留言</h2>
        <Comment className="m-sm-t" itemId={resultId} type={2} />
      </article>

      <DealBtnPark
        contacts={data.contacts}
        contacts_tel={data.contacts_tel}
        className="modal-info-del bor-ra-xs"
        feebackProps={{ itemId: resultId, itemType: 1 }}
      />
    </Modal>
  );
};

export default App;
